import { useEffect, useRef } from 'react'

/**
 * Custom hook that runs an effect only on updates, not on initial mount.
 * Useful for cases where you want to respond to changes but skip the initial render.
 *
 * @param {Function} callback - Function to call on updates
 * @param {Array} dependencies - Dependency array for the effect
 *
 * @example
 * useEffectOnlyOnUpdate(() => {
 *     console.log('Value changed:', value)
 * }, [value])
 */
export default function useEffectOnlyOnUpdate(callback, dependencies) {
    const didMount = useRef(false)

    useEffect(() => {
        if (didMount.current) {
            callback()
        } else {
            didMount.current = true
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...dependencies])
}
